import { styled } from "@mui/material/styles"

import { IContentCard } from "data/contentData/interfaces/mongodb/IContentCard"

import PortableText from "Components/PortableText/PortableText"

export default function TopicContentCard({ card }: { card: IContentCard }) {
    return (
        <StyledContentCardWrapper>
            <PortableText value={card.blockContent} />
        </StyledContentCardWrapper>
    )
}

const StyledContentCardWrapper = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2)
}))
